import { render, staticRenderFns } from "./AdminStammdatenOnboardingModal.vue?vue&type=template&id=11ff5d75&scoped=true"
import script from "./AdminStammdatenOnboardingModal.vue?vue&type=script&lang=js"
export * from "./AdminStammdatenOnboardingModal.vue?vue&type=script&lang=js"
import style0 from "./AdminStammdatenOnboardingModal.vue?vue&type=style&index=0&id=11ff5d75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ff5d75",
  null
  
)

export default component.exports